import './collapsible-section.scss'


import {
    faCaretDown,
    faCaretRight
} from '@fortawesome/free-solid-svg-icons';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
    components: {

    },
    props: ['collapseId', 'title', 'visibleAtStart'],
    template: require('./collapsible-section.html'),
})
export class CollapsibleSection extends ReactiveVue {
    public collapseId: string;
    public title: string;
    public visibleAtStart: boolean;

    private visible: boolean = false;

    // Icons
    private collapseIcon = faCaretRight;

    public mounted() {
        this.subscribeToBus('close_section_topic', () => {
            if (this.visible) {
                this.visible = false;
                this.collapseIcon = faCaretRight;
            }
        })

        this.subscribeToBus('open_section_topic', () => {
            if (!this.visible) {
                this.visible = true;
                this.collapseIcon = faCaretDown;
            }
        })
        this.visible = this.visibleAtStart;
        this.collapseIcon = this.visibleAtStart ? faCaretDown : faCaretRight;
    }

    public onTitleClick() {
        this.switchIconDirection();
    }

    private switchIconDirection() {
        this.collapseIcon = this.visible ? faCaretRight : faCaretDown;
    }
}